"use client";
export default function GlobalErrorBoundary({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="zh-CN">
      <body>
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 16, fontFamily: "system-ui, sans-serif", background: "#f8fafc" }}>
          <h1 style={{ fontSize: 24, fontWeight: 600, color: "#0f172a", margin: 0 }}>系统错误</h1>
          <p style={{ marginTop: 8, color: "#64748b", fontSize: 14 }}>应用遇到严重问题, 请刷新页面重试。</p>
          {error?.digest && <p style={{ marginTop: 12, color: "#94a3b8", fontSize: 12, fontFamily: "monospace" }}>ID: {error.digest}</p>}
          <button onClick={reset} style={{ marginTop: 24, padding: "10px 20px", background: "#0f172a", color: "white", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 14 }}>重试</button>
        </div>
      </body>
    </html>
  );
}
